import { getAvatarImageSource } from "../avatar/avater";
import { Staff } from "../types/staff";

export const getStaffImageSource = (staff: Staff) => {
    if (staff.image != null) {
        return staff.image.url
    }
    return getAvatarImageSource(staff.avatar)
}
